export default {
  mounted(this: { $options: { title: string | (() => string) } }) {
    let { title } = this.$options
    if (title) {
      title = typeof title === 'function' ? title.call(this) : title
      document.title = title
    }
  },
}
